import { render, staticRenderFns } from "./product-add.vue?vue&type=template&id=b4593b06&scoped=true"
import script from "./product-add.vue?vue&type=script&lang=js"
export * from "./product-add.vue?vue&type=script&lang=js"
import style0 from "./product-add.vue?vue&type=style&index=0&id=b4593b06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4593b06",
  null
  
)

export default component.exports